<template>
  <!--<img alt="Vue logo" src="./assets/logo.png" />
  <div class="bg-red-500 font-Roboto">
    This is a test
  </div>
  <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  <div class="container mx-auto">
    <Title />
    <div class="container mx-auto">
      <Buscador />
    </div>
  </div>
</template>

<script>
//import HelloWorld from "./components/HelloWorld.vue";
import Title from "@/components/Title.vue";
import Buscador from "@/components/Buscador.vue";

export default {
  name: "App",
  components: {
    //HelloWorld,
    Title,
    Buscador
  },
};
</script>